module.exports = __webpack_public_path__ + "img/ano-2011-logo.8d21ef5e.svg";